import React from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const TechInsightsEntityContent = EntityContentBlueprint.make({
  name: 'tech-insights',
  params: {
    path: '/insights',
    title: 'Insights',
    filter: 'kind:user',
    loader: async () => {
      const { TechInsightsContent } = await import('./TechInsightsContent');
      return React.createElement(TechInsightsContent);
    },
  },
});

export const techInsightsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [TechInsightsEntityContent],
});
